import { toast } from 'react-hot-toast';
import { useBrand } from '../../Context/Brand/BrandContext';
import UgandaPhoneInput from '../shared/UgandaPhoneInput';

export default function PhoneForm({ onPhoneSubmit, customerContact, onPhoneChange, processing, onBack }) {
  const { brand } = useBrand();
  const accentColor = brand.primaryColor || '#1A7F6D';
  const isValidPhone = (digits) => digits.startsWith('256') && digits.length === 12;
  const handleSubmit = () => {
    const phone = customerContact?.replace(/\D/g, '') || '';
    if (!isValidPhone(phone)) {
      toast.error('Enter 9 digits after the country code');
      return;
    }
    onPhoneSubmit();
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-[13px] font-semibold text-neutral-600 mb-2">
          WhatsApp number
        </label>
        <div>
          <UgandaPhoneInput
            value={customerContact}
            onChange={onPhoneChange}
          />
        </div>
      </div>
      <div className="flex gap-3">
        <button
          type="button"
          onClick={onBack}
          className="h-12 px-5 rounded-xl border border-neutral-200 text-[15px] font-semibold text-neutral-600 hover:bg-neutral-50 hover:text-neutral-800 transition-colors"
        >
          Back
        </button>
        <button
          type="button"
          onClick={handleSubmit}
          disabled={processing}
          className="flex-1 h-12 rounded-xl text-white text-[15px] font-semibold hover:opacity-90 active:scale-[0.99] disabled:opacity-40 disabled:active:scale-100 transition"
          style={{ backgroundColor: accentColor }}
        >
          {processing ? (
            <span className="flex items-center justify-center gap-2">
              <span className="w-4 h-4 rounded-full border-2 border-white/20 border-t-white animate-spin" />
            </span>
          ) : (
            'Open menu'
          )}
        </button>
      </div>
    </div>
  );
}
